import { create } from 'zustand';
import {
  ApprovalStatus,
  CompanyType,
  type CompanySummary,
  type UserSummary,
} from '@biyolink/shared';

/**
 * Oturum durumu. Token'lar httpOnly cookie'de tutulur; burada YALNIZCA
 * kullanıcı ve firma özeti bulunur (`/auth/me` yanıtı).
 */
interface AuthState {
  user: UserSummary | null;
  company: CompanySummary | null;
  /** İlk `/auth/me` çağrısı tamamlanana kadar true — erken yönlendirmeyi engeller. */
  isLoading: boolean;
  setSession: (user: UserSummary | null, company: CompanySummary | null) => void;
  clearSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  company: null,
  isLoading: true,
  setSession: (user, company) => set({ user, company, isLoading: false }),
  clearSession: () => set({ user: null, company: null, isLoading: false }),
}));

// --- Türetilmiş yardımcılar -------------------------------------------------

export function useIsAuthenticated(): boolean {
  return useAuthStore((state) => state.user !== null);
}

export function useIsAdmin(): boolean {
  return useAuthStore((state) => state.user?.role === 'ADMIN');
}

/** Firma onaylandı mı — ilan verme, teklif ve mesaj için gerekli (PRD §7). */
export function useIsApproved(): boolean {
  return useAuthStore((state) => state.company?.approvalStatus === ApprovalStatus.APPROVED);
}

export function useCanSell(): boolean {
  return useAuthStore(
    (state) =>
      state.company?.type === CompanyType.SELLER || state.company?.type === CompanyType.BOTH,
  );
}

export function useCanBuy(): boolean {
  return useAuthStore(
    (state) =>
      state.company?.type === CompanyType.BUYER || state.company?.type === CompanyType.BOTH,
  );
}
